import { Button } from "@/components/ui/button";
import { EtapasCompraRapida } from ".."
import { labelPlural } from "@/utils/copyTituloBilhete";

interface EtapaSelecionarQuantidadeProps {
    alterarEtapa: (etapa: EtapasCompraRapida) => void,
    alterarQuantidade: (quantidade: number) => void,
    quantidade: number
}

export function EtapaSelecionarQuantidade({ quantidade, alterarQuantidade, alterarEtapa }: EtapaSelecionarQuantidadeProps) {

    return (
        <div className="flex flex-col">
            <h1 className="text-center text-primary font-semibold text-xl">
                Quantidade de {labelPlural()}
            </h1>
            <div className="flex items-center justify-center gap-3 mb-5 mt-2">
                <Button
                    disabled={quantidade === 1}
                    onClick={() => {
                        if (quantidade === 1) {
                            return;
                        }
                        alterarQuantidade(quantidade - 1)
                    }}
                    size="sm"
                    variant='outline'>
                    -
                </Button>
                <Button
                    size="sm"
                    variant='outline'>
                    {quantidade}
                </Button>
                <Button
                    disabled={quantidade > 10}
                    onClick={() => {
                        alterarQuantidade(quantidade + 1)
                    }}
                    size="sm"
                    variant='outline'>
                    +
                </Button>
            </div>
            <div className="flex justify-center">
                <Button
                    disabled={quantidade === 0}
                    type="button"
                    onClick={() => alterarEtapa(EtapasCompraRapida.InserirCPF)}
                    variant="foreground"
                    className="mt-2">
                    Continuar
                </Button>
            </div>
        </div>
    )
}